import $ from 'jquery';
import 'url-search-params-polyfill';
import { getOS, getBrowser } from './Helper';

class Analytics {
  /**
   * Default constructor
   * @param  {Number} appId
   * @param  {String} alias
   * @return {Analytics}
   */
  constructor(appId, alias) {
    this.appId = appId;
    this.alias = alias;
    this.limitedUA = `${getBrowser().name}-${getOS()}`;
    this.baseUrl = process.env.REACT_APP_ANALYTICS_URL;
  }

  /**
   * Track event
   * @param  {String} event event name
   * @param  {Object} props event properties
   * @return {Void}
   */
  track(event, props = {}) {
    $.get(`${this.baseUrl}/t/e`, {
      aid: this.appId,
      alias: this.alias,
      ua: this.limitedUA,
      event,
      params: JSON.stringify(props),
    });
  }
}

export default Analytics;



// WEBPACK FOOTER //
// ./src/modules/Analytics.js